// extracted by mini-css-extract-plugin
export default {"item":"ContactEmail-module--item--b5b34","center":"ContactEmail-module--center--6f515"};